import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  LayoutDashboardIcon,
  PackageIcon,
  ShoppingBagIcon,
  MailIcon,
  MenuIcon
} from "./Icons";

export default function MobileBottomNav({ onToggleSidebar, sidebarOpen }) {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <nav className="mobile-native-bottom-nav d-lg-none" aria-label="Mobile Navigation">
      <NavLink
        to="/vendor/dashboard"
        className={`mobile-tab-item ${currentPath.startsWith("/vendor/dashboard") ? "active" : ""}`}
      >
        <div className="mobile-tab-icon-wrap">
          <LayoutDashboardIcon size={20} />
        </div>
        <span className="mobile-tab-label">Dashboard</span>
      </NavLink>

      <NavLink
        to="/vendor/products"
        className={`mobile-tab-item ${currentPath.startsWith("/vendor/products") ? "active" : ""}`}
      >
        <div className="mobile-tab-icon-wrap">
          <PackageIcon size={20} />
        </div>
        <span className="mobile-tab-label">Products</span>
      </NavLink>

      <NavLink
        to="/vendor/orders"
        className={`mobile-tab-item ${currentPath.startsWith("/vendor/orders") ? "active" : ""}`}
      >
        <div className="mobile-tab-icon-wrap">
          <ShoppingBagIcon size={20} />
        </div>
        <span className="mobile-tab-label">Orders</span>
      </NavLink>

      <NavLink
        to="/vendor/messages"
        className={`mobile-tab-item ${currentPath.startsWith("/vendor/messages") ? "active" : ""}`}
      >
        <div className="mobile-tab-icon-wrap">
          <MailIcon size={20} />
        </div>
        <span className="mobile-tab-label">Messages</span>
      </NavLink>

      <button
        type="button"
        onClick={onToggleSidebar}
        className={`mobile-tab-item mobile-tab-button ${sidebarOpen ? "active" : ""}`}
        aria-label="Toggle menu"
      >
        <div className="mobile-tab-icon-wrap">
          <MenuIcon size={22} />
        </div>
        <span className="mobile-tab-label">More</span>
      </button>
    </nav>
  );
}
